import React from 'react';
import event, {EVENTS} from '../../lib/event.js';
import {render} from 'react-dom';
import Cartoon from './cartoon-edit';
// import Audio from "../../lib/audio.js";

/*
  参考ModalManager封装的CartoonEditor类
  调用CartoonEditor.cartoon可打开步骤录制弹窗（弹窗唯一不可重复打开）
  挂载到window对象,可直接通过window.cartoon调用
*/

class CartoonBox {

  static initState(){
    Cartoon.defaultState();
  }

  static stopSpeak(type=1) {
    Cartoon.noSpeak(type);
  }

  // type 气泡类型  1：没有按钮，说完自动消失，2：有按钮的，点击进入下一步
  static speakText(text,title,type=2) {
    Cartoon.speak(text,title,type);
  }

  static onlySpeak(){
    Cartoon.onlySpeak();
  }

  static praise(text){
    Cartoon.good(text);
  }

  static muteHide(){
    Cartoon.muteHide();
  }

  static setsmall(){
    Cartoon.setSmall();
  }

  static cartoonHide(){
    document.getElementById('cartoonEditor').style.display='none';
  }

  static cartoon() {
    const doc = window.document
    const node = doc.createElement('div')
    node.id = 'cartoonEditor' // 保证打开唯一的窗口
    if (doc.getElementById('cartoonEditor')) {
      return
    }
    doc.body.appendChild(node)
    render((
      <div>
        <Cartoon />
      </div>
    ), node)
  }
}

// 挂载到window对象
window.cartoon = CartoonBox.cartoon
window.stopSpeak = CartoonBox.stopSpeak
window.speak = CartoonBox.speakText
window.praise = CartoonBox.praise
window.initState = CartoonBox.initState
window.cartoonHide = CartoonBox.cartoonHide
window.setsmall = CartoonBox.setsmall

export default CartoonBox
